import React from 'react';
import { Url } from 'next/dist/shared/lib/router/router';
import isAbsoluteUrl from '../../../core/helpers/isAbsoluteUrl';
import Link from '../Link/Link';

const CustomLinkRenderer = (props: React.AnchorHTMLAttributes<HTMLAnchorElement>) => {
  const text =
    typeof props.children === 'string' ? props.children : (props.children as string[]).join('');
  return (
    <Link href={props.href as Url} passHref prefetch={false}>
      <a
        className={props.className || 'text-orange-700'}
        style={{ textDecoration: 'underline' }}
        target={isAbsoluteUrl(props.href) ? '_blank' : undefined}
        rel={isAbsoluteUrl(props.href) ? 'noopener noreferrer' : undefined}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        {text}
      </a>
    </Link>
  );
};

export default CustomLinkRenderer;
